import React, { FC } from "react";

import { EditableSection } from "@/components/EditableSection";
import { Section } from "@/components/Section";
import { IConsultantProfile } from "@/data/consultant-profiles";
import { ContactPerson } from "@/views/components/Contact";

import { ConnectionContactSection } from "./ConnectionContactSection";
import { ContactPersonEdit } from "./ContactPersonForm";

interface IEditableConnectionContactSectionProps {
  isManager: boolean;
  record: IConsultantProfile;
  onUpdate?: (profile: IConsultantProfile) => void;
}

export const EditableConnectionContactSection: FC<IEditableConnectionContactSectionProps> = ({
  isManager,
  record,
  onUpdate,
}) => {
  return (
    record.companyRole && (
      <Section borderRadius padding={["lg"]}>
        <EditableSection editable={isManager}>
          {editableProps => (
            <ConnectionContactSection record={record} isManager={isManager}>
              {editableProps.editMode ? (
                <ContactPersonEdit
                  source={record}
                  initialValues={{ contactPerson: record.contactPerson, sharedProfile: record.sharedProfile }}
                  onUpdate={onUpdate}
                  onCancel={editableProps.handleCancelClick}
                  editableProps={editableProps}
                />
              ) : (
                <ContactPerson contactPerson={record.contactPerson} />
              )}
            </ConnectionContactSection>
          )}
        </EditableSection>
      </Section>
    )
  );
};
